class ShopByComponent extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('.shop-by__tab');
    this.panels = this.querySelectorAll('.shop-by__panel');
    this.descriptions = this.querySelectorAll('.shop-by__panel-description');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab.dataset.tab));
      tab.addEventListener('keydown', (e) => this.handleTabKeys(e, tab));
    });

    this.querySelectorAll('.shop-by__arrow').forEach((arrow) => {
      arrow.addEventListener('click', () => this.handleArrow(arrow));
    });

    this.panels.forEach((panel) => {
      const track = panel.querySelector('.shop-by__track');
      if (!track) return;
      this.updateArrowVisibility(panel);
      track.addEventListener('scroll', () => this.updateArrowVisibility(panel), {
        passive: true,
      });
      // Also check when layout changes
      if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(() => this.updateArrowVisibility(panel));
        ro.observe(track);
      }
    });
  }

  activateTab(tabId) {
    if (!tabId) return;
    this.tabs.forEach((t) => {
      const active = t.dataset.tab === tabId;
      t.classList.toggle('is-active', active);
      // Swap theme button classes so the active tab gets primary button styling
      t.classList.toggle('button', active);
      t.classList.toggle('button-secondary', !active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.setAttribute('tabindex', active ? '0' : '-1');
    });
    this.panels.forEach((p) => {
      const active = p.dataset.tab === tabId;
      p.classList.toggle('is-active', active);
      if (active) {
        p.removeAttribute('hidden');
        p.setAttribute('aria-hidden', 'false');
        this.updateArrowVisibility(p);
      } else {
        p.setAttribute('hidden', '');
        p.setAttribute('aria-hidden', 'true');
      }
    });
    if (this.descriptions) {
      this.descriptions.forEach((d) => {
        const active = d.dataset.tab === tabId;
        d.classList.toggle('is-active', active);
        if (active) {
          d.removeAttribute('hidden');
        } else {
          d.setAttribute('hidden', '');
        }
      });
    }
  }

  handleTabKeys(event, currentTab) {
    const tabs = Array.from(this.tabs);
    const currentIndex = tabs.indexOf(currentTab);
    let nextIndex = null;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = tabs.length - 1;

    if (nextIndex !== null) {
      event.preventDefault();
      const next = tabs[nextIndex];
      next.focus();
      this.activateTab(next.dataset.tab);
    }
  }

  handleArrow(arrow) {
    const panel = arrow.closest('.shop-by__panel');
    if (!panel) return;
    const track = panel.querySelector('.shop-by__track');
    if (!track) return;
    const direction = arrow.dataset.direction === 'next' ? 1 : -1;
    const scrollAmount = track.clientWidth * 0.75;
    track.scrollBy({ left: scrollAmount * direction, behavior: 'smooth' });
  }

  updateArrowVisibility(panel) {
    const track = panel.querySelector('.shop-by__track');
    if (!track) return;
    const prev = panel.querySelector('.shop-by__arrow--prev');
    const next = panel.querySelector('.shop-by__arrow--next');
    const maxScroll = track.scrollWidth - track.clientWidth;
    const canScroll = maxScroll > 4;
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft >= maxScroll - 2;

    if (prev) prev.hidden = !canScroll || atStart;
    if (next) next.hidden = !canScroll || atEnd;
  }
}

if (!customElements.get('shop-by-component')) {
  customElements.define('shop-by-component', ShopByComponent);
}
